import React from 'react';
import { Box, Chip, Tooltip, Typography } from '@mui/material';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';
import { profileSummary } from '../constants';

const SENIORITY_TONE = {
  Expert: { bg: '#03407b', color: '#fff' },
  Senior: { bg: '#ebf4fb', color: '#03407b' },
  Confirmé: { bg: '#f0fdf4', color: '#16a34a' },
  Junior: { bg: '#fffbeb', color: '#b45309' },
  Débutant: { bg: '#f1f5f9', color: '#64748b' },
};

export const SeniorityChip = ({ item, size = 'small' }) => {
  const { seniority, years } = profileSummary(item);
  if (!seniority) return null;
  const tone = SENIORITY_TONE[seniority];
  return (
    <Tooltip title={`${years} an${years > 1 ? 's' : ''} d'expérience`}>
      <Chip size={size} label={seniority} sx={{ height: 20, fontSize: '0.66rem', fontWeight: 800, bgcolor: tone.bg, color: tone.color, flexShrink: 0 }} />
    </Tooltip>
  );
};

const Fact = ({ icon, label, value, hint }) => (
  <Box sx={{ p: 1.25, borderRadius: '10px', bgcolor: '#f8fbfe', border: '1px solid #e2edf7', minWidth: 0 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#64748b', '& svg': { fontSize: 15 } }}>
      {icon}
      <Typography sx={{ fontSize: '0.66rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</Typography>
    </Box>
    <Typography noWrap title={value || ''} sx={{ fontSize: '0.88rem', fontWeight: 800, color: value ? '#0f172a' : '#cbd5e1', mt: 0.25 }}>{value || '—'}</Typography>
    {hint && <Typography noWrap title={hint} sx={{ fontSize: '0.72rem', color: '#64748b' }}>{hint}</Typography>}
  </Box>
);

/** Indicators read in 3 seconds: experience, current job, main stack, education. */
const ProfileSummary = ({ item }) => {
  const s = profileSummary(item);
  return (
    <Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1 }}>
        <Fact
          icon={<WorkHistoryOutlinedIcon />}
          label="Expérience"
          value={s.years !== null ? `${s.years} an${s.years > 1 ? 's' : ''}` : null}
          hint={s.seniority}
        />
        <Fact
          icon={<BusinessOutlinedIcon />}
          label="Poste actuel"
          value={s.employer || null}
          hint={[s.since && `depuis ${s.since}`, s.contract].filter(Boolean).join(' · ') || s.role}
        />
        <Fact icon={<CodeOutlinedIcon />} label="Stack principale" value={s.stack.slice(0, 2).join(', ') || null} hint={s.stack.slice(2).join(', ')} />
        <Fact icon={<SchoolOutlinedIcon />} label="Formation" value={s.education || null} hint={s.industries.join(', ')} />
      </Box>
      {s.text && (
        <Typography sx={{ mt: 1, fontSize: '0.78rem', color: '#475569', lineHeight: 1.5 }}>
          <Box component="span" sx={{ fontWeight: 800, color: '#03407b' }}>En bref : </Box>{s.text}
        </Typography>
      )}
    </Box>
  );
};

export default ProfileSummary;
